import { ThreePlanogram } from "../../store/types";
import { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import { Shelves } from "../Shelves";
import { BayBase } from "./BayBase";
import { BayVerticalLine } from "./BayVerticalLine";
import { AisleBreak } from "./AisleBreak";
import { BayRacks } from "./BayRacks";

interface Props {
  bay: PlanogramBay;
  bayIndex: number;
  showDividers?: boolean;
  three: ThreePlanogram;
}

export const Bay = ({ bay, bayIndex, showDividers, three }: Props) => {
  return (
    <>
      {/* A pallet's lanes are its deck, and it stands free of its neighbours. */}
      {!bay.pallet && <BayBase bay={bay} bayIndex={bayIndex} three={three} />}
      {!bay.pallet && <BayVerticalLine bay={bay} bayIndex={bayIndex} three={three} />}
      {bay.splitAfter && bayIndex < bay.planogram.bays.length - 1 && (
        <AisleBreak bay={bay} three={three} />
      )}
      <Shelves shelves={bay.shelves} showDividers={showDividers} three={three} />
      {!bay.pallet && <BayRacks bay={bay} three={three} />}
    </>
  );
};
